import React from 'react'
import { Link } from "react-router-dom"
import { ShoppingCart, Search, Check } from "react-feather"
import clsx from "clsx"

import Card from "./Card"

export default function Product({ link, imgSrc, price, onAddToCart, isInCart,title,discountPercent,rate }) {
	return (
		<Link to={link}
		onClick={() => {
		sessionStorage.setItem("productsScrollY", window.scrollY);
		}}>
		<Card 
			imgSrc={imgSrc} 
			className={clsx(
				 "relative sm:w-72 w-32 sm:h-100 h-60",
				 "!max-w-72",
				// "!max-w-72 !max-h-xs",
				// "rounded-lg m-3 overflow-hidden",
               // "shadow-md hover:shadow-lg transition-all duration-300",
				"rounded-lg m-2",
			)}
		>
			<div className={clsx(
      	"absolute inset-0 text-black text-center",
      	"flex justify-center items-center px-20",
      	"transition ease-out",
      	"group-hover:(bg-black/50)"
    	)}>
    			{/* {isInCart ? (
						<Link to="/cart">
							<ProductButton className="absolute top-3 right-3 !bg-green-500 text-white">
								<Check className='min-w-8' />
							</ProductButton>
						</Link>
					):( 
						<ProductButton onClick={onAddToCart}  className="absolute top-3 right-3 bg-white hover:bg-gray-100">
							<ShoppingCart className='min-w-8' />
						</ProductButton>
					)} */}
    		{/* <Link to={link}>
	    		<ProductButton  className="absolute top-3 left-3 bg-white hover:bg-gray-100">
	    			<Search className='min-w-8'/>
	    		</ProductButton>
    		</Link>  */}
      </div>

	  	  <div
			className={clsx(
				"absolute bottom-0 left-0 w-full",
				"h-14 sm:h-16 md:h-18",
				"bg-white/70 backdrop-blur-sm",
				"flex justify-between items-center",
				"px-2 sm:px-3 md:px-4",
				"font-semibold text-black"
			)}
			>
			<span className="text-xs sm:text-sm md:text-base truncate">
				{title}
			</span>
	  
			<div className="flex flex-col items-end">
				{discountPercent !== 0 ? (
				<>
					<p className="text-[10px] sm:text-xs md:text-sm truncate">
					<s>₹{rate}</s>
					</p>
					<p className="text-xs sm:text-sm md:text-base font-bold text-[var(--text)]">
					₹{price}
					</p>
				</>
				) : (
				<p className="text-sm sm:text-base md:text-lg font-bold text-[var(--text)]">
					₹{rate}
				</p>
				)}
			</div>
		  </div>

	{/* <div
  className={clsx(
    "absolute bottom-0 left-0 w-full h-15",
    "bg-white/70 backdrop-blur-sm",
    "flex justify-between items-center px-4",
    "font-semibold text-black"
  )}
>
  <span className="text-sm truncate">{title}</span>

  <div className="flex flex-col items-end">
    {discountPercent !== 0 ? (
      <>
        <p className="text-sm truncate"> */}
          {/* <s>₹{rate}</s> ({discountPercent}% OFF) */}
		  {/* <s>₹{rate}</s>
        </p>
        <p className="text-[var(--text)] font-bold text-base">
          ₹{price}
        </p>
      </>
    ) : (
      <p className="text-[var(--text)] font-bold text-base">
        ₹{rate}
      </p>
    )}
  </div>
</div> */}


    	{/* <div className={clsx(
    		"absolute bottom-0 right-0 w-20 h-10 m-4",
    		"flex justify-center items-center",
    		"bg-black/50 font-bold text-white",
    	)}>
    		Rs{price}
    	</div>
		<div className={clsx(
    		"absolute bottom-0 right-40 w-20 h-10 m-4",
    		"flex justify-center items-center",
    		" font-bold text-white",
    	)}>
    		{title}
    	</div> */}
		</Card>
		</Link>
	)
}

function ProductButton({ children, className, ...props }) {
	return (
		<button className={`m-5 bg-white w-12 h-12 flex justify-center items-center rounded-full  focus:outline-none ${className}`} {...props}>
			{children}
		</button>
	)
}

// transition-all duration-300 ease-out hover:(px-14)